import { render, staticRenderFns } from "./authSchool.vue?vue&type=template&id=156357e5&"
import script from "./authSchool.vue?vue&type=script&lang=js&"
export * from "./authSchool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports